import { lightenShareLogo } from './workoutShareDrawing';
import regularUrl from '../assets/workout-share/BarlowCondensed-Black.ttf';
import italicUrl from '../assets/workout-share/BarlowCondensed-BlackItalic.ttf';
import vazirUrl from '../assets/workout-share/Vazir-Variable.ttf';
import logoUrl from '../assets/brand/logo.png';
import ribbonUrl from '../assets/workout-share/ribbon-noir.png';
let pending: Promise<{ribbonImage: HTMLImageElement; logoImage: HTMLImageElement; lightLogoImage: HTMLImageElement}> | undefined;
export async function loadShareAssets() {
  if (!pending) pending = (async () => {
    // Bundle Persian glyphs too: canvas/PNG and the Flutter WebView must never
    // depend on a CDN font arriving after the poster has already been drawn.
    const faces = [new FontFace('Barlow Condensed', `url(${regularUrl})`, {weight:'900'}), new FontFace('Barlow Condensed', `url(${italicUrl})`, {weight:'900',style:'italic'}), new FontFace('Vazir', `url(${vazirUrl})`, {weight:'100 900'})];
    await Promise.all(faces.map(async face => {await face.load();document.fonts.add(face);}));
    const image = new Image();image.src = ribbonUrl;await image.decode();
    const sourceLogo = new Image();sourceLogo.src = logoUrl;await sourceLogo.decode();
    // Preserve the green symbol; brighten only the wordmark without a backing plate.
    const logoMask = document.createElement('canvas');logoMask.width=sourceLogo.naturalWidth;logoMask.height=sourceLogo.naturalHeight;
    const logoContext=logoMask.getContext('2d');if(!logoContext) throw new Error('Logo canvas unavailable');
    logoContext.drawImage(sourceLogo,0,0);
    const pixels=logoContext.getImageData(0,0,logoMask.width,logoMask.height);lightenShareLogo(pixels.data);logoContext.putImageData(pixels,0,0);
    const logoImage = new Image();logoImage.src=logoMask.toDataURL('image/png');await logoImage.decode();
    await document.fonts.ready;
    return {ribbonImage: image, logoImage, lightLogoImage: sourceLogo};
  })().catch(error => {pending=undefined;throw error;});
  const image = await pending;
  await Promise.all([
    document.fonts.load('900 68px "Barlow Condensed"', '0123456789'),
    document.fonts.load('italic 900 570px "Barlow Condensed"', '0123456789'),
    document.fonts.load('500 32px Vazir', 'مسافت زمان توان میانگین'),
    document.fonts.load('800 56px Vazir', 'تمرین'),
  ]);
  return image;
}
